import { InputLabel, Stack, TextField } from '@mui/material';
import React from 'react';

interface SettingJsonFieldProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string;
}

const SettingJsonField: React.FC<SettingJsonFieldProps> = ({
  value,
  onChange,
  error,
  helperText,
}) => {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={3}
      alignItems={{ xs: 'stretch', sm: 'center' }}>
      <InputLabel
        sx={{
          minWidth: { xs: 0, sm: 130 },
          color: 'text.primary',
          fontWeight: 500,
          mb: { xs: 1, sm: 0 },
        }}>
        JSON Value
      </InputLabel>
      <TextField
        required
        value={value}
        onChange={onChange}
        size="small"
        sx={{ flex: 1, fontFamily: 'monospace', bgcolor: '#f7f7f7' }}
        fullWidth
        multiline
        minRows={6}
        maxRows={16}
        error={error}
        helperText={helperText}
        placeholder="Paste or write valid JSON here..."
        InputProps={{
          style: {
            fontFamily: 'monospace',
            background: '#f7f7f7',
            borderRadius: 6,
            fontSize: 14,
            lineHeight: 1.6,
            padding: '12px',
            whiteSpace: 'pre',
            wordBreak: 'break-all',
          },
        }}
      />
    </Stack>
  );
};

export default SettingJsonField;
